<template>
    <div style="padding: 10px">
        <van-list v-if="list.length > 0" v-model="loading" :finished="finished"
                  finished-text="没有更多了" @load="getListData" >
            <div v-for="(item,index) in list" :key="index" class="card" @click="gotoDetail(item)" style="background-color: white">
                <div style="margin: 5px 10px 10px 10px; padding-bottom: 10px; font-weight: bold; color: #4E4E4E; font-size: 18px; border-bottom: 1px #EDEDED solid;">
                    {{item.remark}}
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <div>
                        <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'购买时间：' +
                            item.changeDate}}
                        </div>
                        <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'总金额(元)：' +
                            item.funds/100}}
                        </div>
                        <div v-if="item.effectiveDate" style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">保障时间：{{item.effectiveDate|dateFormat('YYYY-MM-DD')}}至{{item.deadline|dateFormat('YYYY-MM-DD')}}
                        </div>
                    </div>
                    <div style="display: flex; align-items: center;">
                        <div :style="{color: stateColor(item)}">{{item.dataState === '0' ? "未支付": '已支付'}}</div>
                        <van-icon name="arrow" color="#C8C8C8" style="margin-right: 5px;"></van-icon>
                    </div>
                </div>
            </div>
        </van-list>
        <div v-else
             style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <van-image :src="require('@/assets/无数据.png')" width="120px" height="94px" style="margin-top: 35%;"/>
            <span style="margin-top: 20px; color: #999999; font-size: 14px;">暂无订单</span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { List, Cell, Icon, Image } from 'vant';
    Vue.use(List).use(Cell).use(Icon).use(Image);

    export default {
        name: "MyCheck",
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                page: 0,
                pageSize: 10
            }
        },
        created() {
            this.getListData()
        },
        methods: {
            stateColor: function (item) {
                return item.dataState === '0' ? "#F76C6C" : "#1C7CF8"
            },
            getListData(){
                if (this.finished) {
                    return;
                }
                this.$axios.get('/inspect/list',{params: {page:this.page, pageSize: this.pageSize}}).then(res => {
                    this.loading = false
                    let datas = res.data.rows;
                    this.list = this.list.concat(datas);
                    if (datas.length < this.pageSize) {
                        this.finished = true;
                    }
                }).catch(err => {
                    this.loading = false
                })
            },
            gotoDetail(item){
                this.$router.push({path: '/checkDetail', query:{id: item.accountDetailId}})
            }

        }
    }
</script>

<style scoped>
    .card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
        margin: 10px;
        background-color: white;
        box-shadow: 0px 2px 4px 0px rgba(231, 231, 231, 0.5);
        border-radius: 4px;
    }
</style>
